import { forwardRef } from 'react';
import SelectUnwrapped, { ISelectProps } from './SelectUnwrapped';

export const Select = forwardRef<HTMLDivElement, ISelectProps<false>>(function InnerSelect(props, ref) {
    return <SelectUnwrapped<false> {...props} innerRef={ref} multiple={false} />;
});
